import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';

export const getSchoolVacationChildren = (family: IFamilyMember[]): IFamilyMember[] => {
  return (family || []).filter((member) => member.role === FamilyMemberType.CHILD);
};

export const getDefaultSchoolVacationAccountIds = (
  family: IFamilyMember[],
  currentYear: number = new Date().getFullYear(),
): number[] => {
  const children = getSchoolVacationChildren(family);

  if (children.length === 1) {
    return [children[0].id];
  }

  return children
    .filter((child) => child.yearBorn !== undefined
      && currentYear - child.yearBorn >= 6
      && currentYear - child.yearBorn <= 18)
    .map((child) => child.id);
};

export const shouldKeepPreviousSchoolImportsByDefault = (family: IFamilyMember[]): boolean => {
  return getSchoolVacationChildren(family).length > 1;
};

export const getSubmittedSchoolVacationAccountIds = (
  family: IFamilyMember[],
  selectedAccountIds: number[],
): number[] => {
  const children = getSchoolVacationChildren(family);

  if (children.length === 1) {
    return [children[0].id];
  }

  const childIds = new Set(children.map((child) => child.id));
  return selectedAccountIds.filter((accountId, index) => childIds.has(accountId)
    && selectedAccountIds.indexOf(accountId) === index);
};

export const schoolVacationChildrenKey = (family: IFamilyMember[]): string => {
  return getSchoolVacationChildren(family)
    .map((child) => `${child.id}:${child.yearBorn === undefined ? '' : child.yearBorn}`)
    .join(',');
};



// WEBPACK FOOTER //
// ./src/components/calendar2/holidays/schoolVacationChildren.ts